<header class="site__header site__header--fixed site__header--logged-in">
    <div class="container">
        <button class="main__menu-icon toggle__trigger pointer" [class.open]="mainMenuOpen" [hidden]="!currentUser || !currentUser.isManager" (click)="toggleMainMenu()">
            <span class="main__menu-bar">&nbsp;</span>
            <span class="main__menu-bar">&nbsp;</span>
            <span class="main__menu-bar">&nbsp;</span>
            <span class="sr-only">Menu</span>
        </button>

        <a *ngIf="currentUser" class="header__logo" [class.menu_hidden]="!currentUser.isManager" [href]="webUrl">
            <sprite-image reference="coho-logo" defaultImage="https://d19qeljo1i8r7y.cloudfront.net/web-images/logos/logo.png" alt="COHO logo"></sprite-image>
        </a>

        <div class="header__options" *ngIf="currentUser">
            <div class="dropdown" [class.open]="userMenuOpen" #userMenuDropdown>
                <button class="header__options-button dropdown__button" (click)="toggleUserMenu()">
                    <div class="profile__image header__profile-image" (click)="toggleUserMenu()">
                        <img [src]="profileImage" [alt]="profileImageAlt">
                    </div>
                </button>

                <ul class="dropdown__menu dropdown__menu--right" (click)="toggleUserMenu(false)">

                    <li>
                        <span class="dropdown__menu-title dropdown__menu-title--with-details">
                            <svg-icon role="img" class="icon icon-user" name="icon-user"></svg-icon>
                                <div class="dropdown__menu-title--details">
                                    <span>{{currentUser.person.fullname}}</span>
                                    <span class="u-text--tiny">{{currentUser.email}}</span>
                                </div>
                        </span>
                        <ul>
                            <li *ngIf="!currentUser?.darkMode">
                                <a href="javascript:void(0)" class="dropdown__menu-item" (click)="toggleDarkMode(true)">
                                    <svg-icon role="img" class="icon icon-dark icon--" name="icon-dark"></svg-icon>
                                    Dark Mode
                                </a>
                            </li>
                            <li *ngIf="currentUser?.darkMode">
                                <a href="javascript:void(0)" class="dropdown__menu-item" (click)="toggleDarkMode(false)">
                                    <svg-icon role="img" class="icon icon-light icon--" name="icon-light"></svg-icon>
                                    Light Mode
                                </a>
                            </li>
                            <li>
                                <a href="javascript:void(0)" (click)="logout()" class="dropdown__menu-item">
                                    <svg-icon role="img" class="icon icon-logout icon--" name="icon-logout"></svg-icon>
                                    Log out
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>

        <ul class="main__navigation toggle__target">
            <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact: true}" *ngIf="(currentUser == null || ((currentUser?.isLooking || currentUser?.isViewing) && !currentUser.isManager && !currentUser.isOwner))">
                <a [routerLink]="['/find-a-home']" (click)="closeMainMenu()">Find a Home</a>
            </li>
            <ng-container *ngIf="(currentUser?.isLooking || currentUser?.isViewing)">
                <li [routerLinkActive]="['active']" *ngFor="let city of mainCities">
                    <a [routerLink]="['/find-a-home', city.reference]" (click)="closeMainMenu()">{{city.label}}</a>
                </li>
            </ng-container>
        </ul>
    </div>
</header>
